var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarhboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "darhboard"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34",
    x: 4.5,
    y: 4.5,
    width: 6.75,
    height: 6.75,
    rx: 1,
    stroke: "white",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 35",
    x: 4.5,
    y: 15.75,
    width: 6.75,
    height: 6.75,
    rx: 1,
    stroke: "white",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 36",
    x: 15.75,
    y: 15.75,
    width: 6.75,
    height: 6.75,
    rx: 1,
    stroke: "white",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 37",
    x: 15.75,
    y: 4.5,
    width: 6.75,
    height: 6.75,
    rx: 1,
    stroke: "white",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarhboard);
export default __webpack_public_path__ + "static/media/darhboard.1b282cb98dd8f23777ac54bc6ef71126.svg";
export { ForwardRef as ReactComponent };